import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ModulesContext = createContext(null);

export const ModulesProvider = ({ children }) => {
  const { user } = useAuth();
  const [enabled, setEnabled] = useState([]);
  const [catalog, setCatalog] = useState({});
  const [gated, setGated] = useState(undefined);
  // Nicht-Staff (z. B. Kunden) unterliegen keinem Menü-Modul-Gating.
  const [unrestricted, setUnrestricted] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchModules = useCallback(async () => {
    if (!user || !['admin', 'superadmin', 'trainer'].includes(user.role)) {
      setUnrestricted(true);
      setLoading(false);
      return;
    }
    setUnrestricted(false);
    try {
      const res = await axios.get(`${API}/settings/enabled-modules`);
      setEnabled(res.data?.enabled || []);
      setCatalog(res.data?.catalog || {});
      setGated(res.data?.gated);
    } catch {
      // FAIL-CLOSED: im Fehlerfall nur Kernfunktionen (keine Module sichtbar).
      setEnabled([]);
      setCatalog({});
      setGated(true);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { fetchModules(); }, [fetchModules]);

  const isModuleEnabled = useCallback((key) => {
    if (!key) return true;
    if (unrestricted) return true;
    return enabled.includes(key);
  }, [unrestricted, enabled]);

  // customer_visible=false  →  neutrale 404 statt Freischalten-Seite.
  const isModuleVisible = useCallback((key) => {
    const m = catalog[key];
    if (!m) return true;
    return m.customer_visible !== false;
  }, [catalog]);

  return (
    <ModulesContext.Provider value={{ enabled, catalog, gated, unrestricted, loading, isModuleEnabled, isModuleVisible, refresh: fetchModules }}>
      {children}
    </ModulesContext.Provider>
  );
};

export const useModules = () => {
  const ctx = useContext(ModulesContext);
  if (!ctx) {
    return { enabled: [], catalog: {}, unrestricted: true, loading: false, isModuleEnabled: () => true, isModuleVisible: () => true, refresh: () => {} };
  }
  return ctx;
};
